import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';
import { Tooltip } from 'react-tooltip';

import GlobalSearch from 'app/client/modules/Search';
import useGlobalSearch from './hooks/useGlobalSearch';
import * as S from './styled';

const Search = () => {
  const { t } = useTranslation();
  const { isOpen, open, close } = useGlobalSearch();

  return (
    <>
      <S.Wrapper>
        <S.Toggle
          onClick={open}
          id="global-search"
          aria-label={t('search:common.search', 'Search')}
        >
          <S.Icon>
            <FontAwesomeIcon icon={byPrefixAndName.fas.search} size="lg" />
          </S.Icon>
        </S.Toggle>

        <Tooltip
          anchorSelect="#global-search"
          border="1px solid var(--rt-border-color, transparent)"
          place="top-end"
          clickable={false}
        >
          <S.TooltipContent>
            <span>{t('search:common.search', 'Search')}</span>
            <S.TooltipDivider />
            <S.FooterHint>
              <S.Keycap>⌘ + K</S.Keycap>
              <span>{t('search:common.or', 'or')}</span>
              <S.Keycap>Ctrl + K</S.Keycap>
            </S.FooterHint>
          </S.TooltipContent>
        </Tooltip>
      </S.Wrapper>

      <GlobalSearch isOpen={isOpen} onClose={close} initialQuery="" />
    </>
  );
};

export default Search;
